export default class extends Controller {

  connect() {
    this.allElements.forEach(el => App.Helpers.listenToCustomEvent(el, 'dynamic-select-change', this.updateAvailableOptions.bind(this)));
  }

  updateAvailableOptions() {
    this.scopedElements.forEach(el => {
      const safeValues = (App.DynamicSelect.getValue(el) || '').split(/,\s*/);
      [...el.querySelectorAll('option')].forEach(option => this.updateSingleOption({ option, safeValues }));
    });
  }

  updateSingleOption({ option, safeValues }) {
    const helperName = `${!safeValues.includes(option.value) && this.unavailableValues.includes(option.value) ? 'disable' : 'enable'}Element`;
    App.Helpers[helperName](option);
  }

  //
  // GETTERS AND SETTERS
  //

  get unavailableValues() {
    return this.specifiedUnavailableValues.concat(this.selectedValues);
  }

  get selectedValues() {
    return this.scopedElements.reduce((values, el) => values.concat((App.DynamicSelect.getValue(el) || '').split(/,\s*/)), []);
  }

  get specifiedUnavailableValues() {
    return JSON.parse(this.data.get('unavailable-values') || '[]');
  }

  get allElements() {
    return this.elementsObject.scopingElements.concat(this.scopedElements);
  }

  get scopedElements() {
    return this.elementsObject.scopedElements;
  }

  get config() {
    return JSON.parse(this.data.get('selectors-config'));
  }

  get elementsObject() {
    return {
      scopingElements: [...this.element.querySelectorAll(this.config.scoping_selector)],
      scopedElements:  [...this.element.querySelectorAll(this.config.scoped_selector)]
    }
  }

  get allSelectors() {
    return Object.keys(this.config).reduce((collection, key) => collection.concat([this.config[key]]), []);
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/messages/message_tasks/message-tasks-available-options-controller.js